import { render, staticRenderFns } from "./AboutUsers.vue?vue&type=template&id=55745133&scoped=true"
import script from "./AboutUsers.vue?vue&type=script&lang=js"
export * from "./AboutUsers.vue?vue&type=script&lang=js"
import style0 from "./AboutUsers.vue?vue&type=style&index=0&id=55745133&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55745133",
  null
  
)

export default component.exports